import type { InjectionKey } from 'vue';

import type { OmwConfig } from '@/types/ConfigTypes';

export const configKey: InjectionKey<OmwConfig> = Symbol('OmwConfig');
